import React from 'react';

import { Container, IconImage, IconTitle } from './styles';

export enum Icons {
  success = 'success',
  alertOrder = 'alert-order',
  creditCardLimit = 'credit-card-limit',
  creditCardNumber = 'credit-card-number',
  paymentFail = 'payment-fail',
  productOutOfStock = 'product-out-of-stock',
  orderCanceled = 'order-canceled',
  boletoSuccess = 'boleto-success',
  boletoExpired = 'boleto-expired',
  pix = 'pix',
  pixExpired = 'pix-expired',
}

interface Props {
  icon: Icons;
  text?: string;
  primary?: boolean;
  'data-cy'?: string;
}

const ImageTitle = (props: Props) => (
  <Container>
    <IconImage
      data-cy={props['data-cy'] && `${props['data-cy']}-image`}
      src={require(`../../assets/images/${props.icon}.svg`)}
      width={props.icon.includes('card') ? 216 : 152}
      height={props.icon.includes('card') ? 136 : 152}
    />
    <IconTitle
      data-cy={props['data-cy'] && `${props['data-cy']}-text`}
      primary={props.primary}>
        {props.text || ''}
    </IconTitle>
  </Container>
);
export default ImageTitle;
